import React, { useState } from "react";
import styles from "./styles/OutputWindowSettlement.module.css";
import { useTranslation } from "react-i18next";
import useNumberFormat from "../../../hooks/useNumberFormat";

/**
 * Amount window output component
 * Used in the ticket info section in the search page
 */
const OutputWindowSettlement = ({ fullAmount, remain, currency }) => {
    const { t } = useTranslation();
    const formatNum = useNumberFormat();
    const paid = fullAmount - remain;
    return (
        <div className={`${styles.main_output_menu_container}`}>
            <div className={`${styles.output_menu_container}`}>
                {/* ______________________________________________________ Amount */}
                <div className={`${styles.output_amount_label}`}>
                    {t(`amount`)}:
                </div>
                <div className={`${styles.output_amount_value}`}>
                    {currency}
                    {formatNum(fullAmount)}
                </div>
                {/* ______________________________________________________ Amount */}

                <div className={`${styles.output_sign} ${styles.sign1}`}>-</div>

                {/* ______________________________________________________ Paid */}
                <div className={`${styles.output_tax_label}`}>{t(`paid`)}:</div>
                <div className={`${styles.output_tax_value}`}>
                    {currency}
                    {formatNum(paid)}
                </div>
                {/* ______________________________________________________ Paid */}

                <div className={`${styles.output_ruler_container}`}>
                    <hr className={`${styles.output_ruler}`} />
                </div>
                {/* ______________________________________________________ Total */}

                <div className={`${styles.output_total_label}`}>
                    {t(`remain`)}:
                </div>
                <div className={`${styles.output_total_value}`}>
                    {currency}
                    {formatNum(remain)}
                </div>
                {/* ______________________________________________________ Total */}
            </div>
        </div>
    );
};

export default OutputWindowSettlement;
